import { InboxOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import type { ReactNode } from "react";

/**
 * Пустое состояние таблицы.
 *
 * Строка «Пусто» посреди белого прямоугольника читается как «не загрузилось».
 * Иконка и подпись отличают пустую очередь от сломанного запроса — а очередь
 * заявок в норме как раз пуста.
 */
export function EmptyState({
  icon = <InboxOutlined aria-hidden />,
  title,
  hint = null,
}: {
  icon?: ReactNode;
  title: ReactNode;
  hint?: ReactNode;
}) {
  return (
    <div style={{ padding: "28px 16px", textAlign: "center" }}>
      <div
        aria-hidden
        style={{ fontSize: 32, color: "var(--ant-color-text-quaternary)", lineHeight: 1 }}
      >
        {icon}
      </div>
      <Typography.Paragraph type="secondary" style={{ marginTop: 10, marginBottom: hint === null ? 0 : 4 }}>
        {title}
      </Typography.Paragraph>
      {hint !== null && (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {hint}
        </Typography.Text>
      )}
    </div>
  );
}
